import { DateDataBaseType } from "./database";
import { SecurityType } from "./security";
import { SexEnum } from "./sex";

export type FeatureType = {
  id: number;
  type: FeatureEnum;
  isActive: boolean;
  connectedObjectId: number;
  data: unknown;
} & DateDataBaseType

export enum FeatureEnum {
  Human = "human"
}

export enum PhoneNumberEnum {  
  CellPhone = "cell-phone",
  WorkPhone = "work-phone",   
  HomePhone = "home-phone" 
}

export const getPhoneNumberMetaData = (phoneNumber: string): PhoneNumberMetaDataType | undefined => {  
  let result: PhoneNumberMetaDataType | undefined;

  switch (phoneNumber) {
    case PhoneNumberEnum.HomePhone:
      result = {
        title: "Fixe"        
      }
      break;
    case PhoneNumberEnum.CellPhone:
      result = {
        title: "Mobile"        
      }
      break;
    case PhoneNumberEnum.WorkPhone:
      result = {
        title: "Bureau"        
      }
      break;  
  }

  return result;
}

export const toFeatureEnumOf = (value: string): FeatureEnum | undefined => {
  switch (value) {
    case FeatureEnum.Human:
      return FeatureEnum.Human;
    default:
      return undefined;
  }
}

export type FeatureMetaDataType = {
  title: string;
  description?: string;
  icon: string;
  decor?: string;
}

export type PhoneNumberMetaDataType = {
  title: string;  
}

export type HumanType = SecurityType & {
  name: string | null,
  dateOfBirth: Date | null,
  sex: SexEnum | null,
  address: string | null,
  emergencyContact: string | null,
  school: string | null,
  image: string | null,
  physicalDescription: string | null,
  informationAdditional: string | null,
  language: string | null
}

export type DetailsFeature = {
  url: string;
  feature: FeatureType;
  user: {
    isPremium: boolean;
  };
}



